import { apiRequest } from './authService';

export const pingApi = async () => {
  const data = await apiRequest('/catalogos/getAutoTipo');
  if(data){
    return true;
  } else {
    return false;
  }
};

export const fetchTipos = async () => {
  const data = await apiRequest('/catalogos/getAutoTipo');
  return data.map(item => ({
    value: item.clave,
    label: item.desc
  }));
};

export const fetchModelos = async ( {tipo} ) => {
  const data = await apiRequest('/catalogos/getModelos?tipo_vehiculo=' + tipo);
  return data.map(item => ({
    value: item.modelo,
    label: item.modelo
  }));
};

export const fetchMarcas = async ( {tipo, modelo} ) => {
  const data = await apiRequest('/catalogos/getMarcas?tipo_vehiculo=' + tipo + '&modelo=' + modelo);
  return data.map(item => ({
    value: item.clave,
    label: item.armadora
  }));
};

export const fetchSubMarcas = async ( {tipo, modelo, marca} ) => {
  const data = await apiRequest('/catalogos/getSubMarcas?tipo_vehiculo=' + tipo + '&modelo=' + modelo + '&marca=' + marca);
  return data.map(item => ({
    value: item.clave,
    label: item.submarca
  }));
};

export const fetchDescripciones = async ( {tipo, modelo, marca, subMarca} ) => {
  const data = await apiRequest('/catalogos/getDescripciones?tipo_vehiculo=' + tipo + '&modelo=' + modelo + '&marca=' + marca + '&submarca=' + subMarca);
  return data.map(item => ({
    value: item.clave,
    label: item.descripcion
  }));
};

export const validateZipCode = async ( {zipCode} ) => {
  const data = await apiRequest('/catalogos/validaCP/' + zipCode );
  if (data.d_codigo) {
    return {
      isValid: true,
    };
  }

  return {
    isValid: false,
  };
};

export const fetchTaxRegime = async () => {
  const data = await apiRequest('/catalogos/getRegimenesFiscales/');
  return data.map(item => ({
    value: item.clave,
    label: item.desc
  }));
};

export const fetchAdressData = async ( {zipCode} ) => {
  try {
    if (!zipCode || zipCode.length < 5) {
      throw new Error("Código postal inválido");
    }

    const response = await apiRequest('/catalogos/getColonias?cp=' + zipCode);

    if (!Array.isArray(response) || response.length === 0) {
      throw new Error("No se encontraron resultados para este código postal");
    }

    const estado = response[0].d_estado || "";
    const municipio = response[0].d_mnpio || "";

    const colonias = response.map((item) => ({
      value: item.id_asenta_cp_cons,
      label: item.d_asenta,
    }));

    const coloniasUnicas = colonias.filter(
      (c, i, arr) => arr.findIndex((x) => x.value === c.value) === i
    );

    return {
      estado,
      municipio,
      colonias: coloniasUnicas,
    };

  } catch (error) {
    return {
      estado: "",
      municipio: "",
      colonias: [],
      error: error.message,
    };
  }
  
};


export const fetchCotizacion = async (quote) => {

  const { vehicleData, driverData, contractorData } = quote;

  const payload = {
    vehiculo: {
      tipo_vehiculo: vehicleData.tipo,
      modelo: vehicleData.modelo,
      clave: vehicleData.descripcion,
    },
    conductor: {
      fecha_nacimiento: driverData.fechaNacimiento,
      codigo_postal: driverData.codigoPostal,
      sexo: driverData.genero,
    },
    contratante: {
      email: contractorData.correoElectronico,
      telefono: contractorData.telefonoMovil,
      rfc: contractorData.rfc,
    },
  };

  const data = await apiRequest('/cotizacion/crear', {
    method: "POST",
    body: JSON.stringify(payload),
  });

  
  if (data.error === true) {
    return { success: false, uuid: '' };
  } else {
    return { success: true, uuid: data.uuid };
  }

};

const TITLES = {
  1: "AMPLIA",
  4: "PREMIUM",
  5: "AMPLIA GL"
};

const FEATURES = {
  "AMPLIA": [
    "Robo Total",
    "Responsabilidad Civil por Daños a Terceros",
    "Protección Legal",
    "Gastos Médicos Ocupantes",
    "Extención de Resposabilidad Civil",
    "Club GNP Autos",
    "Daños Materiales Pérdidas Parciales",
    "Daños Materiales Pérdidas Totales",
    "Cristales"
  ],
  "AMPLIA GL": [
    "Robo Total",
    "Responsabilidad Civil por Daños a Terceros",
    "Protección Legal",
    "Gastos Médicos Ocupantes",
    "Extención de Resposabilidad Civil",
    "Club GNP Autos",
    "Daños Materiales Pérdidas Parciales",
    "Daños Materiales Pérdidas Totales",
    "Cristales",
    "Auto Sustituto Perdida Total"
  ],
  "PREMIUM": [
    "Robo Total",
    "Responsabilidad Civil por Daños a Terceros",
    "Protección Legal",
    "Gastos Médicos Ocupantes",
    "Extención de Resposabilidad Civil",
    "Club GNP Autos",
    "Daños Materiales Pérdidas Parciales",
    "Daños Materiales Pérdidas Totales",
    "Cristales",
    "Auto Sustituto Plus",
    "Ayuda Para Llantas y Rines",
    "Llaves de Repuesto",
    "Paga Cero y Robo Parcial Plus"
  ]
};

export const fetchCoverage = async ({ uuid }) => {
  const data = await apiRequest('/cotizacion/cotizar/' + uuid);
  
  if (!Array.isArray(data)) return [];

  return data.map(item => ({
    package_id: item.paquete_id,
    no_cotizacion: item.no_cotizacion,
    price: parseFloat(item.prima_total),
    title: TITLES[item.paquete_id],
    features: FEATURES[TITLES[item.paquete_id]] || []
  }));
};


export const selectpackage = async ({ packageId, uuid }) => {

  const payload = {
    paquete_id: packageId
  };

  const data = await apiRequest('/cotizacion/elegirPaquete/' + uuid, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

  if (data.exito === 1) {
    return { success: true };
  } else {
    return { success: false };
  }
};

export const putCotizacion = async ({ payload, uuid}) => {

  const data = await apiRequest('/cotizacion/actualizarDatos/'+ uuid, {
    method: "POST",
    body: JSON.stringify(payload),
  });

  if (data.exito === 1) {
    return { success: true};
  } else {
    return { success: false};
  }

};

export const fetchInsurance = async ({ payload, uuid }) => {

  const data = await apiRequest('/cotizacion/datosVehiculo/' + uuid, {
    method: "POST",
    body: JSON.stringify(payload),
  });

  if (data.exito === 1) {
    return { success: true };
  } else {
    return { success: false };
  }

};

export const fetchIssue = async ({ uuid }) => {

  const data = await apiRequest('/cotizacion/emitir/' + uuid);

  if (data.error) {
    return { 
      success: false 
    };
  } else {
    return { 
      success: true,
      no_poliza: data.no_poliza
    };
  }

};